export default "__VITE_PUBLIC_ASSET__a6bd05b4__"